import { useMemo } from 'react';

import LinkBankAccount from './LinkOpenBankingRevamp/LinkBankAccount';
import { useGetContext } from '../../../../api/lendingApi/lendingApiQueries';
import { TOfferDataRequirement } from '../../../../types';
import { getLinkedBankAccountDetails } from '../../OpenBanking/trueLayer.helpers';

type TProps = {
  resolutionMethods: TOfferDataRequirement['actions'][number]['resolution_methods'];
};

const BankStatements = ({ resolutionMethods }: TProps) => {
  const { context } = useGetContext();

  const linkedBankAccount = useMemo(() => {
    if (!resolutionMethods || !context) return undefined;
    return getLinkedBankAccountDetails(resolutionMethods, context);
  }, [resolutionMethods, context]);

  return <LinkBankAccount linkedBankAccount={linkedBankAccount} />;
};

export default BankStatements;
